import { Action, createReducer, on } from '@ngrx/store';

import { AuthAction } from '../actions';
import { AuthState } from '../states/auth.state';

const initialState: AuthState = {
  ready: false,
  token: '',
  info: null,
};

export const AuthReducer = createReducer(
  initialState,
  on(AuthAction.SetToken, (state, { token, ready }) => ({
    ...state,
    token,
    ready,
  })),
  on(AuthAction.SetInfo, (state, { info }) => ({
    ...state,
    info,
  })),
  on(AuthAction.ResetAll, () => initialState)
);
